"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lustre = exports.trek = exports.panels = exports.isLedKey = void 0;
function isLedKey(key) {
    if (typeof key === 'string') {
        return [
            'title',
            'article',
            'img',
            'price',
            'wats',
            'color',
            'diameter',
            'diameterCut',
            'colorLightK',
            'lightStream',
            'rotation',
            'patron',
            'material',
            'wats-segment'
        ].includes(key);
    }
    else {
        return false;
    }
}
exports.isLedKey = isLedKey;
exports.panels = [
    {
        title: 'SAPRA LP110',
        wats: '6',
        color: 'white',
        article: '2200001',
        diameter: '120',
        diameterCut: '95',
        lightStream: '480',
        colorLightK: '4000',
        img: '/img/lamps/all-lamp/2200001.jpg',
        price: '1.9'
    },
    {
        title: 'SAPRA LP110',
        wats: '9',
        color: 'white',
        article: '2200002',
        diameter: '143',
        diameterCut: '120',
        lightStream: '720',
        colorLightK: '4000',
        img: '/img/lamps/all-lamp/2200001.jpg',
        price: '2.52'
    },
    {
        title: 'SAPRA LP110',
        wats: '12',
        color: 'white',
        article: '2200003',
        diameter: '170',
        diameterCut: '120',
        lightStream: '720',
        colorLightK: '4000',
        img: '/img/lamps/all-lamp/2200001.jpg',
        price: '2.52'
    },
    {
        wats: '15',
        title: 'SAPRA LP110',
        color: 'белая',
        article: '2200004',
        diameter: '192',
        diameterCut: '160',
        colorLightK: '4000',
        lightStream: '1200',
        img: '/img/lamps/all-lamp/2200001.jpg',
        price: '3.84'
    },
    {
        wats: '18',
        title: 'SAPRA LP110',
        color: 'белая',
        article: '2200005',
        diameter: '223',
        diameterCut: '190',
        colorLightK: '4000',
        lightStream: '1440',
        img: '/img/lamps/all-lamp/2200001.jpg',
        price: '4.99'
    },
    {
        wats: '6',
        title: 'SAPRA LP200 со стеклом',
        color: 'белая',
        article: '2200006',
        diameter: '100',
        diameterCut: '70',
        colorLightK: '4000',
        lightStream: '480',
        img: '/img/lamps/all-lamp/2200006.jpg',
        price: '1.9'
    },
    {
        wats: '9',
        title: 'SAPRA LP200 со стеклом',
        color: 'белая',
        article: '2200007',
        diameter: '120',
        diameterCut: '95',
        colorLightK: '4000',
        lightStream: '720',
        img: '/img/lamps/all-lamp/2200006.jpg',
        price: '3.39'
    },
    {
        wats: '12',
        title: 'SAPRA LP200 со стеклом',
        color: 'белая',
        article: '2200008',
        diameter: '160',
        diameterCut: '125',
        colorLightK: '4000',
        lightStream: '960',
        img: '/img/lamps/all-lamp/2200006.jpg',
        price: '3.99'
    },
    {
        wats: '7',
        title: 'SAPRA LP300',
        color: 'белая',
        article: '2200009',
        diameter: '103',
        diameterCut: '75',
        colorLightK: '4000',
        lightStream: '560',
        img: '/img/lamps/all-lamp/2200009.jpg',
        price: '2.49'
    },
    {
        wats: '9',
        title: 'SAPRA LP300',
        color: 'белая',
        article: '2200010',
        diameter: '112',
        diameterCut: '85',
        colorLightK: '4000',
        lightStream: '720',
        img: '/img/lamps/all-lamp/2200009.jpg',
        price: '1.99'
    },
    {
        wats: '12',
        title: 'SAPRA LP300',
        color: 'белая',
        article: '2200011',
        diameter: '136',
        diameterCut: '110',
        colorLightK: '4000',
        lightStream: '960',
        img: '/img/lamps/all-lamp/2200009.jpg',
        price: '3.99'
    },
    {
        wats: '3+2',
        title: 'SAPRA LP400',
        color: 'белая',
        article: '2200012',
        diameter: '100',
        diameterCut: '70',
        colorLightK: '4000+6500',
        lightStream: '400',
        img: '/img/lamps/all-lamp/2200012.jpg',
        price: '2.7'
    },
    {
        wats: '6+3',
        title: 'SAPRA LP400',
        color: 'белая',
        article: '2200013',
        diameter: '145',
        diameterCut: '107',
        colorLightK: '4000+6500',
        lightStream: '720',
        img: '/img/lamps/all-lamp/2200012.jpg',
        price: '4.1'
    },
    {
        wats: '12+4',
        title: 'SAPRA LP400',
        color: 'белая',
        article: '2200014',
        diameter: '195',
        diameterCut: '155',
        colorLightK: '4000+6500',
        lightStream: '1280',
        img: '/img/lamps/all-lamp/2200012.jpg',
        price: '4.3'
    },
    {
        wats: '6',
        title: 'SAPRA LP500',
        color: 'белая',
        article: '2200015',
        diameter: '100',
        diameterCut: '50-85',
        colorLightK: '4000',
        lightStream: '480',
        img: '/img/lamps/all-lamp/2200015.jpg',
        price: '2.12'
    },
    {
        wats: '8',
        title: 'SAPRA LP500',
        color: 'белая',
        article: '2200016',
        diameter: '118',
        diameterCut: '50-95',
        colorLightK: '4000',
        lightStream: '640',
        img: '/img/lamps/all-lamp/2200015.jpg',
        price: '2.6'
    },
    {
        wats: '15',
        title: 'SAPRA LP500',
        color: 'белая',
        article: '2200017',
        diameter: '173',
        diameterCut: '50-150',
        colorLightK: '4000',
        lightStream: '1200',
        img: '/img/lamps/all-lamp/2200015.jpg',
        price: '4.13'
    },
    {
        wats: '20',
        title: 'SAPRA LP500',
        color: 'белая',
        article: '2200018',
        diameter: '230',
        diameterCut: '50210',
        colorLightK: '4000',
        lightStream: '1600',
        img: '/img/lamps/all-lamp/2200015.jpg',
        price: '5.16'
    },
    {
        wats: '7',
        title: 'SAPRA LP600',
        color: 'белая',
        article: '2200019',
        diameter: '80',
        diameterCut: '55',
        colorLightK: '4000',
        lightStream: '560',
        img: '/img/lamps/all-lamp/2200019.jpg',
        price: '3.95'
    },
    {
        wats: '7',
        title: 'SAPRA LP610',
        color: 'чёрная',
        article: '2200020',
        diameter: '80',
        diameterCut: '55',
        colorLightK: '4000',
        lightStream: '560',
        img: '/img/lamps/all-lamp/2200020.jpg',
        price: '3.42'
    },
    {
        wats: '7',
        title: 'SAPRA LP601',
        color: 'белая',
        article: '2200021',
        diameter: '82 * 82',
        diameterCut: '55',
        colorLightK: '4000',
        lightStream: '560',
        img: '/img/lamps/all-lamp/2200021.jpg',
        price: '3.95'
    },
    {
        wats: '7',
        title: 'SAPRA LP611',
        color: 'чёрная',
        article: '2200022',
        diameter: '8282',
        diameterCut: '55',
        colorLightK: '4000',
        lightStream: '560',
        img: '/img/lamps/all-lamp/2200022.jpg',
        price: '3.42'
    },
    {
        wats: '10',
        title: 'SAPRA LP701 круг',
        color: 'белая',
        article: '2200023',
        diameter: '85',
        diameterCut: '50-70',
        colorLightK: '4000',
        lightStream: '1000',
        img: '/img/lamps/all-lamp/2200023.jpg',
        price: '2.18'
    },
    {
        wats: '10',
        title: 'SAPRA LP701 круг',
        color: 'белая',
        article: '2300403',
        diameter: '85',
        diameterCut: '50-70',
        colorLightK: '6400',
        lightStream: '1000',
        img: '/img/lamps/all-lamp/2200023.jpg',
        price: '2.18'
    },
    {
        wats: '16',
        title: 'SAPRA LP701 круг',
        color: 'белая',
        article: '2200024',
        diameter: '120',
        diameterCut: '50-105',
        colorLightK: '4000',
        lightStream: '1600',
        img: '/img/lamps/all-lamp/2200023.jpg',
        price: '3.28'
    },
    {
        wats: '16',
        title: 'SAPRA LP701 круг',
        color: 'белая',
        article: '2300404',
        diameter: '120',
        diameterCut: '50-105',
        colorLightK: '6400',
        lightStream: '1600',
        img: '/img/lamps/all-lamp/2200023.jpg',
        price: '3.28'
    },
    {
        wats: '24',
        title: 'SAPRA LP701 круг',
        color: 'белая',
        article: '2200025',
        diameter: '170',
        diameterCut: '50-155',
        colorLightK: '4000',
        lightStream: '2400',
        img: '/img/lamps/all-lamp/2200023.jpg',
        price: '4.55'
    },
    {
        wats: '24',
        title: 'SAPRA LP701 круг',
        color: 'белая',
        article: '2300405',
        diameter: '170',
        diameterCut: '50-155',
        colorLightK: '6400',
        lightStream: '2400',
        img: '/img/lamps/all-lamp/2200023.jpg',
        price: '4.55'
    },
    {
        wats: '36',
        title: 'SAPRA LP701 круг',
        color: 'белая',
        article: '2200026',
        diameter: '220',
        diameterCut: '50-200',
        colorLightK: '4000',
        lightStream: '3600',
        img: '/img/lamps/all-lamp/2200023.jpg',
        price: '6.37'
    },
    {
        wats: '36',
        title: 'SAPRA LP701 круг',
        color: 'белая',
        article: '2300406',
        diameter: '220',
        diameterCut: '50-200',
        colorLightK: '6400',
        lightStream: '3600',
        img: '/img/lamps/all-lamp/2200023.jpg',
        price: '6.37'
    },
    {
        wats: '10',
        title: 'SAPRA LP711 квадрат',
        color: 'белая',
        article: '2200027',
        diameter: '85×85',
        diameterCut: '50×50 - 80×80',
        colorLightK: '4000',
        lightStream: '1000',
        img: '/img/lamps/all-lamp/2200027.jpg',
        price: '2.18'
    },
    {
        wats: '10',
        title: 'SAPRA LP711 квадрат',
        color: 'белая',
        article: '2300407',
        diameter: '85×85',
        diameterCut: '50×50 - 80×80',
        colorLightK: '6400',
        lightStream: '1000',
        img: '/img/lamps/all-lamp/2200027.jpg',
        price: '2.18'
    },
    {
        wats: '16',
        title: 'SAPRA LP711 квадрат',
        color: 'белая',
        article: '2200028',
        diameter: '125×125',
        diameterCut: '50×50 - 115×115',
        colorLightK: '4000',
        lightStream: '1600',
        img: '/img/lamps/all-lamp/2200027.jpg',
        price: '3.28'
    },
    {
        wats: '16',
        title: 'SAPRA LP711 квадрат',
        color: 'белая',
        article: '2300408',
        diameter: '125×125',
        diameterCut: '50×50 - 115×115',
        colorLightK: '6400',
        lightStream: '1600',
        img: '/img/lamps/all-lamp/2200027.jpg',
        price: '3.28'
    },
    {
        wats: '24',
        title: 'SAPRA LP711 квадрат',
        color: 'белая',
        article: '2200029',
        diameter: '170×170',
        diameterCut: '50×50 - 165×165',
        colorLightK: '4000',
        lightStream: '2400',
        img: '/img/lamps/all-lamp/2200027.jpg',
        price: '4.55'
    },
    {
        wats: '24',
        title: 'SAPRA LP711 квадрат',
        color: 'белая',
        article: '2300409',
        diameter: '170×170',
        diameterCut: '50×50 - 165×165',
        colorLightK: '6400',
        lightStream: '2400',
        img: '/img/lamps/all-lamp/2200027.jpg',
        price: '4.55'
    },
    {
        wats: '36',
        title: 'SAPRA LP711 квадрат',
        color: 'белая',
        article: '2200030',
        diameter: '220×220',
        diameterCut: '50×50 - 210×210',
        colorLightK: '4000',
        lightStream: '3600',
        img: '/img/lamps/all-lamp/2200027.jpg',
        price: '6.37'
    },
    {
        wats: '36',
        title: 'SAPRA LP711 квадрат',
        color: 'белая',
        article: '2300410',
        diameter: '220×220',
        diameterCut: '50×50 - 210×210',
        colorLightK: '6400',
        lightStream: '3600',
        img: '/img/lamps/all-lamp/2200027.jpg',
        price: '6.37'
    },
    {
        wats: '10',
        title: 'SAPRA LP1000',
        color: 'белая',
        article: '2200375',
        diameter: '115×42',
        diameterCut: 'нет ',
        colorLightK: '4000',
        lightStream: '700',
        img: '/img/lamps/all-lamp/2200375.jpg',
        price: '13.66'
    },
    {
        wats: '10',
        title: 'SAPRA LP1000',
        color: 'чёрная',
        article: '2200376',
        diameter: '115×42',
        diameterCut: 'нет ',
        colorLightK: '4000',
        lightStream: '700',
        img: '/img/lamps/all-lamp/2200376.jpg',
        price: '13.66'
    },
    {
        wats: '20',
        title: 'SAPRA LP1000',
        color: 'белая',
        article: '2200377',
        diameter: '160×42',
        diameterCut: 'нет ',
        colorLightK: '4000',
        lightStream: '1400',
        img: '/img/lamps/all-lamp/2200375.jpg',
        price: '15.98'
    },
    {
        wats: '20',
        title: 'SAPRA LP1000',
        color: 'чёрная',
        article: '2200378',
        diameter: '160×42',
        diameterCut: 'нет ',
        colorLightK: '4000',
        lightStream: '1400',
        img: '/img/lamps/all-lamp/2200376.jpg',
        price: '15.98'
    },
    {
        wats: '28',
        title: 'SAPRA LP1000',
        color: 'белая',
        article: '2200379',
        diameter: '215×42',
        diameterCut: 'нет ',
        colorLightK: '4000',
        lightStream: '1960',
        img: '/img/lamps/all-lamp/2200375.jpg',
        price: '18.7'
    },
    {
        wats: '28',
        title: 'SAPRA LP1000',
        color: 'чёрная',
        article: '2200380',
        diameter: '215×42',
        diameterCut: 'нет ',
        colorLightK: '4000',
        lightStream: '1960',
        img: '/img/lamps/all-lamp/2200376.jpg',
        price: '18.7'
    }
];
exports.trek = [
    {
        title: 'SAPRA SP010 TR',
        wats: 'max. 13 W',
        color: 'белый',
        article: '2200093',
        diameter: 'Ø85×130 мм',
        rotation: '→ 315⁰ / ↑ 90⁰',
        patron: 'GX53',
        material: 'металл + пластик',
        img: '/img/lamps/trek/1.jpg',
        price: '9.88'
    },
    {
        title: 'SAPRA SP010 TR',
        wats: 'max. 13 W',
        color: 'чёрный',
        article: '2200094',
        diameter: 'Ø85×130 мм',
        rotation: '→ 315⁰ / ↑ 90⁰',
        patron: 'GX53',
        material: 'металл + пластик',
        img: '/img/lamps/trek/2.jpg',
        price: '7.55'
    },
    {
        title: 'SAPRA SP011 TR',
        wats: 'max. 13 W',
        color: 'белый',
        article: '2200095',
        diameter: 'Ø55×170 мм',
        rotation: '→ 315⁰ / ↑ 180⁰',
        patron: 'GU10',
        material: 'металл + пластик',
        img: '/img/lamps/trek/3.jpg',
        price: '9.4'
    },
    {
        title: 'SAPRA SP011 TR',
        wats: 'max. 13 W',
        color: 'чёрный',
        article: '2200096',
        diameter: 'Ø55×170 мм',
        rotation: '→ 315⁰ / ↑ 180⁰',
        patron: 'GU10',
        material: 'металл + пластик',
        img: '/img/lamps/trek/4.jpg',
        price: '9.4'
    },
    {
        title: 'SAPRA SP012 TR',
        wats: 'max. 13 W',
        color: 'белый',
        article: '2200097',
        diameter: 'Ø60×125 мм',
        rotation: '→ 360⁰ / ↑ 270⁰',
        patron: 'GU10',
        material: 'металл + пластик',
        img: '/img/lamps/trek/5.jpg',
        price: '3.75'
    },
    {
        title: 'SAPRA SP012 TR',
        wats: 'max. 13 W',
        color: 'чёрный',
        article: '2200098',
        diameter: 'Ø60×125 мм',
        rotation: '→ 360⁰ / ↑ 270⁰',
        patron: 'GU10',
        material: 'металл + пластик',
        img: '/img/lamps/trek/6.jpg',
        price: '3.75'
    },
    {
        title: 'SAPRA SP013 TR',
        wats: 'max. 13 W',
        color: 'белый',
        article: '2200099',
        diameter: '60×60×120 мм',
        rotation: '→ 360⁰ / ↑ 270⁰',
        patron: 'GU10',
        material: 'металл + пластик',
        img: '/img/lamps/trek/7.jpg',
        price: '3.75'
    },
    {
        title: 'SAPRA SP013 TR',
        wats: 'max. 13 W',
        color: 'чёрный',
        article: '2200100',
        diameter: '60×60×120 мм',
        rotation: '→ 360⁰ / ↑ 270⁰',
        patron: 'GU10',
        material: 'металл + пластик',
        img: '/img/lamps/trek/8.jpg',
        price: '3.75'
    },
    {
        title: 'SAPRA SP014 TR',
        wats: 'max. 13 W',
        color: 'белый',
        article: '2200101',
        diameter: 'Ø54×160 мм',
        rotation: '→ 315⁰ / ↑ 180⁰',
        patron: 'GU10',
        material: 'металл + пластик',
        img: '/img/lamps/trek/9.jpg',
        price: '7.89'
    },
    {
        title: 'SAPRA SP015 TR',
        wats: 'max. 13 W',
        color: 'белый',
        article: '2200102',
        diameter: 'Ø54×160 мм',
        rotation: '→ 315⁰ / ↑ 180⁰',
        patron: 'GU10',
        material: 'металл + пластик',
        img: '/img/lamps/trek/10.jpg',
        price: '7.07'
    },
    {
        title: 'SAPRA SP015 TR',
        wats: 'max. 13 W',
        color: 'чёрный',
        article: '2200103',
        diameter: 'Ø54×160 мм',
        rotation: '→ 315⁰ / ↑ 180⁰',
        patron: 'GU10',
        material: 'металл + пластик',
        img: '/img/lamps/trek/11.jpg',
        price: '7.07'
    }
];
exports.lustre = [
    {
        title: 'SAPRA SP001 SV',
        color: 'белый',
        article: '2200091',
        diameter: 'Ø54×300',
        diameterCut: 'Ø60×20',
        wats: 'max. 13 Вт',
        patron: 'GU10',
        material: 'металл',
        img: '/img/lamps/lustre/13.jpg',
        price: '10.9'
    },
    {
        title: 'SAPRA SP001 SV',
        color: 'чёрный',
        article: '2200092',
        diameter: 'Ø54×300',
        diameterCut: 'Ø60×20',
        wats: 'max. 13 Вт',
        patron: 'GU10',
        material: 'металл',
        img: '/img/lamps/lustre/14.jpg',
        price: '10.9'
    },
    {
        title: 'SAPRA SP002 SV',
        color: 'белый',
        article: '2200319',
        diameter: 'Ø54×300',
        diameterCut: 'Ø60×20',
        wats: 'max. 13 Вт',
        patron: 'GU10',
        material: 'металл',
        img: '/img/lamps/lustre/15.jpg',
        price: '18.5'
    },
    {
        title: 'SAPRA SP002 SV',
        color: 'чёрный',
        article: '2200320',
        diameter: 'Ø54×300',
        diameterCut: 'Ø60×20',
        wats: 'max. 13 Вт',
        patron: 'GU10',
        material: 'металл',
        img: '/img/lamps/lustre/16.jpg',
        price: '18.5'
    },
    {
        title: 'SAPRA LPL 101/1',
        color: 'чёрный',
        article: '2200321',
        diameter: 'Ø250×230',
        diameterCut: 'Ø120×20',
        wats: '',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/17.jpg',
        price: '36.0'
    },
    {
        title: 'SAPRA LPL 101/3K',
        color: 'чёрный',
        article: '2200322',
        diameter: 'Ø250×230',
        diameterCut: 'Ø250×25',
        wats: '',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/18.jpg',
        price: '96.0'
    },
    {
        title: 'SAPRA LPL 101/3Р',
        color: 'чёрный',
        article: '2200323',
        diameter: 'Ø250×230',
        diameterCut: '750×60×20',
        wats: '',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/19.jpg',
        price: '99.0'
    },
    {
        title: 'SAPRA LPL 102/1',
        color: 'чёрный',
        article: '2200324',
        diameter: 'Ø250×290',
        diameterCut: 'Ø120×20',
        wats: '',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/20.jpg',
        price: '38.5'
    },
    {
        title: 'SAPRA LPL 102/3K',
        color: 'чёрный',
        article: '2200325',
        diameter: 'Ø250×290',
        diameterCut: 'Ø250×25',
        wats: '',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/21.jpg',
        price: '100.7'
    },
    {
        title: 'SAPRA LPL 102/3Р',
        color: 'чёрный',
        article: '2200326',
        diameter: 'Ø250×290',
        diameterCut: '750×60×20',
        wats: '',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/22.jpg',
        price: '107'
    },
    {
        title: 'SAPRA LPL 103/1',
        color: 'чёрный',
        article: '2200327',
        diameter: 'Ø135×220',
        diameterCut: 'Ø120×20',
        wats: '',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/23.jpg',
        price: '19'
    },
    {
        title: 'SAPRA LPL 103/3K',
        color: 'чёрный',
        article: '2200328',
        diameter: 'Ø135×220',
        diameterCut: 'Ø250×25',
        wats: '',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/24.jpg',
        price: '57'
    },
    {
        title: 'SAPRA LPL 103/3Р',
        color: 'чёрный',
        article: '2200329',
        diameter: 'Ø135×220',
        diameterCut: '550×40×20',
        wats: '',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/25.jpg',
        price: '60'
    },
    {
        title: 'SAPRA LPL 104/1',
        color: 'чёрный/янтарь',
        article: '2200330',
        diameter: 'Ø150×135',
        diameterCut: 'Ø120×20',
        wats: '',
        patron: 'E27',
        material: 'стекло',
        img: '/img/lamps/lustre/26.jpg',
        price: '17'
    },
    {
        title: 'SAPRA LPL 104/3Р',
        color: 'чёрный/янтарь',
        article: '2200331',
        diameter: 'Ø150×135',
        diameterCut: '550×40×20',
        wats: '',
        patron: 'E27',
        material: 'стекло',
        img: '/img/lamps/lustre/27.jpg',
        price: '51'
    },
    {
        title: 'SAPRA LPL 105/1',
        color: 'чёрный/белый',
        article: '2200332',
        diameter: 'Ø150×135',
        diameterCut: 'Ø120×20',
        wats: '',
        patron: 'E27',
        material: 'стекло',
        img: '/img/lamps/lustre/28.jpg',
        price: '17'
    },
    {
        title: 'SAPRA LPL 105/3Р',
        color: 'чёрный/белый',
        article: '2200333',
        diameter: 'Ø150×135',
        diameterCut: '550×40×20',
        wats: '',
        patron: 'E27',
        material: 'стекло',
        img: '/img/lamps/lustre/29.jpg',
        price: '51'
    },
    {
        title: 'SAPRA LPL 106/1',
        color: 'чёрный/белый',
        article: '2200334',
        diameter: 'Ø155×170',
        diameterCut: 'Ø120×20',
        wats: '',
        patron: 'E27',
        material: 'стекло',
        img: '/img/lamps/lustre/30.jpg',
        price: '21'
    },
    {
        title: 'SAPRA LPL 106/3Р',
        color: 'чёрный/белый',
        article: '2200335',
        diameter: 'Ø155×170',
        diameterCut: '550×40×20',
        wats: '',
        patron: 'E27',
        material: 'стекло',
        img: '/img/lamps/lustre/31.jpg',
        price: '57'
    },
    {
        title: 'SAPRA LPL 107/1',
        color: 'чёрный/серый',
        article: '2200336',
        diameter: 'Ø160×190',
        diameterCut: 'Ø120×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'стекло',
        img: '/img/lamps/lustre/1.jpg',
        price: '24.5'
    },
    {
        title: 'SAPRA LPL 107/3Р',
        color: 'чёрный/серый',
        article: '2200337',
        diameter: 'Ø160×190',
        diameterCut: '550×40×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'стекло',
        img: '/img/lamps/lustre/2.jpg',
        price: '67.0'
    },
    {
        title: 'SAPRA LPL 107/1',
        color: 'чёрный/янтарь',
        article: '2200338',
        diameter: 'Ø160×190',
        diameterCut: 'Ø120×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'стекло',
        img: '/img/lamps/lustre/3.jpg',
        price: '24.5'
    },
    {
        title: 'SAPRA LPL 107/3Р',
        color: 'чёрный/янтарь',
        article: '2200339',
        diameter: 'Ø160×190',
        diameterCut: '550×40×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'стекло',
        img: '/img/lamps/lustre/4.jpg',
        price: '67.0'
    },
    {
        title: 'SAPRA LPL 108/1',
        color: 'чёрный',
        article: '2200340',
        diameter: '230×75',
        diameterCut: 'Ø120×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/5.jpg',
        price: '22.2'
    },
    {
        title: 'SAPRA LPL 108/3Р',
        color: 'чёрный',
        article: '2200341',
        diameter: '230×200×75',
        diameterCut: '600×60×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/6.jpg',
        price: '67.0'
    },
    {
        title: 'SAPRA LPL 109/1',
        color: 'чёрный',
        article: '2200342',
        diameter: '250×250×75',
        diameterCut: 'Ø120×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/7.jpg',
        price: '29.0'
    },
    {
        title: 'SAPRA LPL 109/3Р',
        color: 'чёрный',
        article: '2200343',
        diameter: '250×250×75',
        diameterCut: '600×60×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/8.jpg',
        price: '65.0'
    },
    {
        title: 'SAPRA LPL 110/1',
        color: 'чёрный',
        article: '2200344',
        diameter: '180×290×70',
        diameterCut: 'Ø120×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/9.jpg',
        price: '35.6'
    },
    {
        title: 'SAPRA LPL 110/3Р',
        color: 'чёрный',
        article: '2200345',
        diameter: '180×290×70',
        diameterCut: '600×60×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/10.jpg',
        price: '70.0'
    },
    {
        title: 'SAPRA LPL 111/1',
        color: 'чёрный',
        article: '2200346',
        diameter: '200×295×75',
        diameterCut: 'Ø120×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/11.jpg',
        price: '31.0'
    },
    {
        title: 'SAPRA LPL 111/3Р',
        color: 'чёрный',
        article: '2200347',
        diameter: '200×295×75',
        diameterCut: '600×60×20',
        wats: 'max. 20 Вт',
        patron: 'E27',
        material: 'металл',
        img: '/img/lamps/lustre/12.jpg',
        price: '67.0'
    }
];
